import React from 'react';
import { RadioButtonGroup, RadioButtonTheme } from 'wix-ui-tpa/cssVars';
import { classes } from './DeliveryOptionsPicker.st.css';
import { useDeliverySectionData } from '../../provider/useDeliverySectionContext';
import { DeliveryOptionsPickerHooks } from './DeliveryOptionsPicker';
import { DeliveryOption } from './DeliveryOption';
export const DeliveryOptionsGroup = props => {
  const {
    deliveryOptions,
    title,
    type,
    shouldHideHeaders
  } = props;
  const {
    selectedDeliveryOption
  } = useDeliverySectionData();
  if (!deliveryOptions.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.sectionContainer
  }, /*#__PURE__*/React.createElement(RadioButtonGroup, {
    label: shouldHideHeaders ? undefined : /*#__PURE__*/React.createElement("span", {
      "data-hook": DeliveryOptionsPickerHooks.sectionTitle({
        id: type
      })
    }, title),
    "data-hook": DeliveryOptionsPickerHooks.deliveryRadioGroup({
      id: type
    }),
    className: classes.radioGroup,
    name: type,
    theme: RadioButtonTheme.Box,
    value: selectedDeliveryOption == null ? void 0 : selectedDeliveryOption.groupId,
    fluid: true,
    onChange: undefined
  }, deliveryOptions.map(deliveryOption => /*#__PURE__*/React.createElement(DeliveryOption, {
    key: deliveryOption.groupId,
    deliveryOption: deliveryOption
  }))));
};
//# sourceMappingURL=DeliveryOptionsGroup.js.map